import React from 'react'
import { DisplayListPagination } from '../../../../components/TapUi';
import LoadVehicleType from './LoadVehicleType';

function LoadDetailData() {
  return (
        <div className="tab_content_header" style={{ maxHeight: "72vh", overflowY: "scroll" }}>
            <LoadVehicleType type='load'/>
            <LoadVehicleType type='vehicle'/>
            <LoadVehicleType type='material'/>
            <LoadVehicleType type='consignment'/>
        </div>
    );
}

export default LoadDetailData